import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from 'Core/components/Page';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Card from 'Core/components/FormElements/Card';

const EasyCreditSuccess = () => {
  document.title = 'Payment Portal - Application Completed';
  useScrollTop();
  const { t } = useTranslation();

  return (
    <Page title={t('easyCredit.page.financing.header')} withStepProgress={false} stickyFooter hideAlert>
      <div className="mt-12 max-w-4xl mx-auto">
        <Card className="bg-gradient-to-br from-white to-gray-50 shadow-xl border-0 overflow-hidden">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-emerald-400 via-green-400 to-emerald-500"></div>
          
          <div className="p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Success Icon */}
              <div className="flex-shrink-0 w-40 md:w-56">
                <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-6 shadow-inner">
                  <div className="w-full aspect-square flex items-center justify-center">
                    <div className="relative">
                      <div className="w-32 h-32 md:w-40 md:h-40 bg-gradient-to-br from-emerald-500 to-green-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                        <svg className="w-20 h-20 md:w-24 md:h-24 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      {/* Decorative circles */}
                      <div className="absolute -top-2 -right-2 w-8 h-8 bg-emerald-300 rounded-full opacity-60"></div>
                      <div className="absolute -bottom-2 -left-2 w-6 h-6 bg-green-300 rounded-full opacity-60"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-sm font-semibold mb-4">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Success
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                  Application Completed Successfully
                </h2>

                <div className="flex flex-col sm:flex-row gap-3 items-center justify-center md:justify-start mt-8">
                  <div className="flex items-center gap-2 text-emerald-700">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm font-medium">Application Submitted</span>
                  </div>
                  {/* <div className="flex items-center gap-2 text-emerald-700">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm font-medium">Confirmation Sent</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </Page>
  );
};

export default EasyCreditSuccess;

